module.exports = "/virtual-football-league/img/amblems/left/logos/RealMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/RealMadrid.png
// module id = 2118
// module chunks = 4